import { render, staticRenderFns } from "./Bkk.vue?vue&type=template&id=372c4806&scoped=true&"
import script from "./Bkk.vue?vue&type=script&lang=js&"
export * from "./Bkk.vue?vue&type=script&lang=js&"
import style0 from "./Bkk.vue?vue&type=style&index=0&id=372c4806&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c4806",
  null
  
)

export default component.exports